import script from "./GlobalButtonGrey.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalButtonGrey.vue?vue&type=script&setup=true&lang=js"

import "./GlobalButtonGrey.vue?vue&type=style&index=0&id=040546d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040546d4"]])

export default __exports__